<template>
  <div class="page">
    <div class="flex mb20 flex-start gonghai">
      <img
        class="top_img"
        src="https://imgcdn.hemiao100.com/ThemePictures/shenglizhou.png"
        alt=""
      />
      <div class="top_rt">
        <h6 class="top_title">公海客户</h6>
        <p class="top_txt">
          激活无导购的客户，提供最强有力的工具和抓手，最终实现客服工作的可视、智能、简单、有效，赋予客户运营全新能量。
        </p>
        <el-button type="primary" size="small" @click="usePopu" class="mr10"
          >立即使用</el-button
        >
      </div>
    </div>
    <div class="mb20 content">
      <h6>你是否有以下痛点？</h6>
      <img
        class="content_img1"
        src="https://imgcdn.hemiao100.com/ThemePictures/BG1.png"
        alt=""
      />
      <h6 style="margin-bottom: 30px">公海客户能做什么？</h6>
      <img
        class="content_img2"
        src="https://imgcdn.hemiao100.com/ThemePictures/BG2.png"
        alt=""
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="公海客户使用引导"
      width="60%"
      :visible.sync="dialogVisible"
    >
      <div class="btn-wrapper">
        <hm-step :steps="steps" :step="stepsNum" disabledNext></hm-step>
        <div class="steps_content steps_content1" v-if="stepsNum == 1">
          <p class="steps_content_txt">
            您的公海的客户（无导购客户）有<span>{{ vipNum }}</span>
            个人，使用前可以先给部分客户分配导购哦
          </p>
          <div class="steps_content_day">
            <span class="steps_content_day_lt">根据客户最后</span>
            <el-input
              v-model="inputDay"
              type="number"
              clearable
              placeholder="请输入天数"
              class="content_day"
            ></el-input>
            <span class="steps_content_day_rt"
              >天以内最后1次购买的订单分配给销售的导购</span
            >
          </div>
          <div class="steps_content_day">
            <span class="steps_content_day_lt">导购有多个时</span>
            <el-select
              v-model="value"
              clearable
              placeholder="请选择"
              class="content_sel"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                clearable
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!--        <div class="steps_content steps_content2" v-if="stepsNum == 2">
          <p class="steps_content_txt mb10">
            成功寻找到<span>{{ dataCount }}</span>
            个客户，分配成功后无导购的客户将会变成有导购状态
          </p>
          <div class="table">
            <el-table
              :data="dataList"
              style="width: 100%"
              ref="table"
              stripe
              border
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                label="会员手机号"
                prop="memberMobile"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="客户姓名"
                prop="memberName"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="最后一次消费时间"
                prop="lastShoppingTime"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="分配导购"
                prop="employeeRealname"
              ></el-table-column>
            </el-table>
            <div class="hm-pagination" style="margin-top: 20px">
              <el-pagination
                background
                :total="total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>-->
        <div class="steps_content steps_content2" v-if="stepsNum == 2">
          <p class="steps_content_txt" style="color: #222222">
            <i></i
            >您可以启用以下开关，让系统自动帮助您分配客户，也可以跳过操作以后设置
          </p>
          <div class="steps_content_day">
            <el-switch
              v-model="switchValue1"
              style="display: block"
              inactive-text="公海客户自动分配"
            >
            </el-switch>
            <p class="switch_txt">
              开启后，公海中无导购的客户自动按照规则分配导购
            </p>
            <el-switch
              style="display: block"
              v-model="switchValue2"
              inactive-text="客户自动进入公海"
            >
            </el-switch>
            <p class="switch_txt">
              开启后，导购不维护自己的客户就会导致客户与导购脱离关系，进入公海客户中，并且在禾电掌上显示，扫码右边二维码查看效果
            </p>
          </div>
        </div>
        <div class="btn_box" v-if="stepsNum == 1">
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('next')"
            class="btn"
            >下一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('go4')"
            class="btn"
            >暂不分配</el-button
          >
        </div>
        <!-- <div class="btn_box" v-if="stepsNum == 2">
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('back')"
            class="btn"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('start')"
            class="btn"
            >开始分配</el-button
          >
        </div>-->
        <div class="btn_box" v-if="stepsNum == 2">
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('back')"
            class="btn"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="nextBtn('go')"
            class="btn"
            >进入应用</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="公海客户自行分配导购"
      width="75%"
      :visible.sync="dialogVisible1"
    >
      <div class="btn-wrapper">
        <div class="steps_content steps_content1"></div>
        <div class="steps_content_day">
          <div class="steps_content_day">
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 10px; width: 100%"
              v-model="radio1"
              label="1"
              >导购联系后分配给联系的导购
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="2"
            >
              <span class="radio_span">导购联系后</span>
              <el-input
                style="margin: 0 10px"
                v-model="input11"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天内产生单次消费且大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input12"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元后分配给联系的导购</span>
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="3"
            >
              <span class="radio_span">导购联系后</span>
              <el-input
                style="margin: 0 10px"
                v-model="input13"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天内产生单次消费且大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input14"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元后分配给联系的导购</span>
            </el-radio>
            <el-radio
              class="steps_content_day_lt"
              style="margin-bottom: 15px; width: 100%"
              v-model="radio1"
              label="4"
            >
              <span class="radio_span">根据下次购买高于</span>
              <el-input
                style="margin: 0 10px"
                v-model="input15"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元分配给销售导购</span>
            </el-radio>
            <div class="steps_content_day" style="padding-left: 20px">
              <span class="steps_content_day_lt">导购有多个时</span>
              <el-select
                v-model="valueSel"
                clearable
                placeholder="请选择"
                class="content_sel"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <el-button
            type="primary"
            size="small"
            @click="popBtn('pop1', 'yes')"
            class="btn"
            >确定</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="popBtn('pop1', 'no')"
            class="btn"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="客户自动进入公海"
      width="75%"
      :visible.sync="dialogVisible2"
    >
      <div class="btn-wrapper">
        <div class="steps_content steps_content1"></div>
        <div class="steps_content_day">
          <div class="steps_content_day">
            <el-checkbox
              v-model="checked1"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="a"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp1"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且按照最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp2"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天，消费之和低于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp3"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked4"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="d"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp31"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且按照最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp32"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天,全部消费订单金额都低于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp33"
                placeholder="请填写金额"
                clearable
              ></el-input>
              <span class="radio_span">元时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked2"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="b"
            >
              <span class="radio_span">客户绑定导购天数大于</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp11"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天且最近</span>
              <el-input
                style="margin: 0 10px"
                v-model="checkInp12"
                placeholder="请填写天数"
                clearable
              ></el-input>
              <span class="radio_span">天以上未进行联系时进入公海</span>
            </el-checkbox>

            <el-checkbox
              v-model="checked3"
              class="steps_content_day_lt"
              style="width: 100%; margin-bottom: 20px"
              label="c"
            >
              <span class="radio_span">导购离职后客户自动进入公海</span>
            </el-checkbox>
          </div>
        </div>
        <div class="btn_box">
          <el-button
            type="primary"
            size="small"
            @click="popBtn('pop2', 'yes')"
            class="btn"
            >确定</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="popBtn('pop2', 'no')"
            class="btn"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getLoginUser } from "@/utils/auth";
import HmStep from "@/components/HmStep";

export default {
  components: {
    HmStep
  },
  data() {
    return {
      hintType: null,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible: false,
      stepsNum: 1,
      steps: [
        {
          link: "GHindex",
          name: "公海客户的初始分配"
        },

        {
          link: "GHindex",
          name: "应用设置"
        },
        {
          link: "GHindex",
          name: "进入应用"
        }
      ],
      inputDay: null,
      value: "no",
      options: [
        {
          value: "maxSale",
          label: "分配给销售金额多的导购"
        },
        {
          value: "no",
          label: "不分配，以后导购联系或销售分配"
        }
      ],
      options2: [
        {
          value: "maxSale",
          label: "分配给销售多的导购"
        },
        {
          value: "no",
          label: "不分配，以后导购联系或销售分配"
        }
      ],
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      switchValue1: false,
      switchValue2: false,
      checkInp1: "",
      checkInp2: "",
      checkInp3: "",
      checkInp11: "",
      checkInp12: "",
      checkInp31: "",
      checkInp32: "",
      checkInp33: "",
      valueSel: "分配给销售多的导购",
      unassignGuiderRuleList1: [],
      unassignGuiderRuleList2: [],
      unassignGuiderRuleList3: [],
      unassignGuiderRuleList4: [],
      assignGuiderRule: {},
      RuleSwitch: [],
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      vipNum: 0,
      dataCount: 0,
      dataList: [],
      input1: "",
      input2: "",
      radio1: "",
      radio2: "",
      radio3: "",
      radio4: "",
      radio90: "",
      input11: "",
      input12: "",
      input13: "",
      input14: "",
      input15: "",
      storeCode: null
    };
  },
  watch: {
    switchValue1: {
      handler(val) {
        console.log("switchValue1", val);
        if (val) {
          this.dialogVisible1 = true;
        } else {
          this.dialogVisible1 = false;
        }
      }
    },
    switchValue2: {
      handler(val) {
        console.log("switchValue2--", val);
        if (val) {
          this.dialogVisible2 = true;
        } else {
          this.dialogVisible2 = false;
        }
      }
    },
    radio1: {
      handler(val) {
        console.log("radio1---", val);
      }
    },
    valueSel: {
      handler(val) {
        console.log("valueSel---", val);
      }
    }
  },
  created() {
    // this.storeCode = getLoginUser().storeCode;

    this.changePage();
  },
  mounted() {
    this.queryList();
  },
  destroyed() {},
  methods: {
    // 页面初始化判断是否进入首页
    async changePage() {
      const { result } = await this.$store.dispatch("gonghaiStoreInit");
      console.log("result----进入应用", result);
      if (result == "yes") {
        this.$router.push({
          name: "Userd"
        });
      }
    },
    async nextBtn(type) {
      console.log("this.stepsNum ==", this.stepsNum);
      // let historyAssignRule = {};
      if (this.stepsNum == 1 && type == "next") {
        if (!this.inputDay) {
          this.$message({
            message: "请正确设置规则天数！",
            type: "warning"
          });
          return;
        }
        if (!this.value) {
          this.$message({
            message: "请正确设置多导购分配规则！",
            type: "warning"
          });
          return;
        }
        this.hintType = "next";
        this.stepsNum = 2;
      }
      if (this.stepsNum == 1 && type == "go4") {
        this.$confirm(
          "如果跳过本步骤，将不能按照历史订单分配导购，只能按之后新的订单分配，请确认是否跳过",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.hintType = "go4";
          this.stepsNum = 2;
        });
      }
      if (this.stepsNum == 2 && type == "back") {
        this.stepsNum = 1;
      }
      if (this.stepsNum == 2 && type == "start") {
        console.log("start---");
        const { result } = await this.$store.dispatch(
          "getGonghaiGuider",
          this.dataList
        );
        console.log(result);
        if (result) {
          this.stepsNum = 3;
        }
      }
      if (this.stepsNum == 2 && type == "go") {
        let params = {
          unassignGuiderRuleList: this.RuleSwitch,
          unassignGuiderRuleSwitch: this.switchValue2 ? "yes" : "no",
          assignGuiderRule: this.assignGuiderRule,
          assignGuiderRuleSwitch: this.switchValue1 ? "yes" : "no",
          isAssignHistoryHiggSeasMemner: this.hintType == "next" ? "yes" : "no",
          historyAssignRule: {
            manyGuiderRule: this.value,
            ruleDay: this.inputDay
          }
        };
        this.gonghaiInit(params);
      }
    },
    popBtn(pop, type) {
      if (type == "yes" && pop == "pop1") {
        if (!this.radio1 && !this.valueSel) {
          console.log("请输入天数和金额！");
          this.$message({
            message: "请设置！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 2 && (!this.input11 || !this.input12)) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 3 && (!this.input13 || !this.input14)) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (this.radio1 == 4 && !this.input15) {
          this.$message({
            message: "请输入金额！",
            type: "warning"
          });
          return false;
        }

        if (this.radio1 == 1) {
          this.assignGuiderRule = {
            allotGuiderType: "contact",
            ruleTypeNumber: "contact",
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 2) {
          this.assignGuiderRule = {
            allotGuiderType: "contact",
            ruleTypeNumber: "consumeContact",
            contactDay: this.input11,
            saleMoney: this.input12,
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 3) {
          this.assignGuiderRule = {
            allotGuiderType: "sale",
            ruleTypeNumber: "consumeSale",
            contactDay: this.input13,
            saleMoney: this.input14,
            manyGuiderRule: this.valueSel
          };
        }
        if (this.radio1 == 4) {
          this.assignGuiderRule = {
            allotGuiderType: "sale",
            ruleTypeNumber: "sale",
            saleMoney: this.input15,
            manyGuiderRule: this.valueSel
          };
        }
        console.log("--assignGuiderRule", this.assignGuiderRule);
        this.dialogVisible1 = false;
      }
      if (type == "no" && pop == "pop1") {
        this.switchValue1 = false;
        this.dialogVisible1 = false;
      }
      if (type == "yes" && pop == "pop2") {
        console.log("checked1", this.checked1);
        console.log(this.checkInp1, this.checkInp2, this.checkInp3);

        if (
          this.checked1 &&
          (!this.checkInp1 || !this.checkInp2 || !this.checkInp3)
        ) {
          console.log("请输入天数和金额！");
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (this.checked2 && (!this.checkInp11 || !this.checkInp12)) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (
          this.checked4 &&
          (!this.checkInp31 || !this.checkInp32 || !this.checkInp33)
        ) {
          this.$message({
            message: "请输入天数和金额！",
            type: "warning"
          });
          return false;
        }
        if (
          !this.checked1 &&
          !this.checked2 &&
          !this.checked3 &&
          !this.checked3
        ) {
          this.$message({
            message: "请选择",
            type: "warning"
          });
          return false;
        }
        if (this.checked1) {
          this.unassignGuiderRuleList1 = [
            {
              bindingDay: this.checkInp1,
              ruleDay: this.checkInp2,
              saleMoney: this.checkInp3,
              ruleTypeNumber: "notConsume"
            }
          ];
        } else {
          this.unassignGuiderRuleList1 = [];
        }
        if (this.checked4) {
          this.unassignGuiderRuleList4 = [
            {
              bindingDay: this.checkInp31,
              ruleDay: this.checkInp32,
              saleMoney: this.checkInp33,
              ruleTypeNumber: "notConsumeEvery"
            }
          ];
        } else {
          this.unassignGuiderRuleList4 = [];
        }
        if (this.checked2) {
          this.unassignGuiderRuleList2 = [
            {
              bindingDay: this.checkInp11,
              ruleDay: this.checkInp12,
              ruleTypeNumber: "notContact"
            }
          ];
        } else {
          this.unassignGuiderRuleList2 = [];
        }
        if (this.checked3) {
          this.unassignGuiderRuleList3 = [
            {
              ruleTypeNumber: "leave"
            }
          ];
        } else {
          this.unassignGuiderRuleList3 = [];
        }
        this.RuleSwitch = this.unassignGuiderRuleList1
          .concat(this.unassignGuiderRuleList2)
          .concat(this.unassignGuiderRuleList3)
          .concat(this.unassignGuiderRuleList4);
        this.RuleSwitch = this.unassignGuiderRuleList1
          .concat(this.unassignGuiderRuleList2)
          .concat(this.unassignGuiderRuleList3)
          .concat(this.unassignGuiderRuleList4);
        this.dialogVisible2 = false;
      }
      if (type == "no" && pop == "pop2") {
        this.switchValue2 = false;
        this.dialogVisible2 = false;
      }
    },
    async gonghaiInit(params) {
      const { result } = await this.$store.dispatch("gonghaiInit", params);
      this.$router.push({
        name: "Userd"
      });
    },
    // usePopu弹框
    usePopu() {
      this.dialogVisible = true;
    },
    async queryList() {
      const { result } = await this.$store.dispatch("getGonghaiMember");
      if (result) {
        this.vipNum = result;
      }
    },
    paging(page) {
      this.currentPage = page;
      //   this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      //   this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
div,
p,
h6 {
  margin: 0;
  padding: 0;
}

.gonghai {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  height: 240px;
  background: #fff;
  margin-right: 20px;
  .top_img {
    margin: 0 30px;
    width: 180px;
    height: 180px;
  }
  .top_rt {
    flex: 1;
    text-align: left;
    padding-top: 10px;
    .top_title {
      line-height: 40px;
      font-size: 20px;
      font-weight: 500;
      color: #222222;
      margin: 0;
      padding: 0;
    }
    .top_txt {
      color: #222222;
      font-size: 14px;
      line-height: 40px;
      margin-bottom: 40px;
    }
  }
}
.content {
  height: 860px;
  background: #ffffff;
  padding: 45px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-right: 20px;
  h6 {
    line-height: 35px;
    font-size: 24px;
    color: #222222;
    font-weight: 500;
    text-align: center;
  }
  .content_img1 {
    width: 528px;
    height: 162px;
    margin: 30px;
    transform: translate(-50%);
    margin: 60px;
    margin-left: 50%;
  }
  .content_img2 {
    width: 1418px;
    height: 330px;
    margin: 30px;
    margin-left: 50%;
    transform: translate(-50%);
  }
}
.priceBt {
  .el-radio__input {
    display: none;
  }
}

.paycode {
  width: 240px;
}
.btn-wrapper {
  border-top: 1px solid #dddddd;
}
.steps_content {
  border-top: 1px solid #dddddd;
  padding: 15px 0;
  .steps_content_txt {
    font-size: 14px;
    color: #999999;
    line-height: 40px;
    padding-bottom: 10px;
    span {
      color: #0081e5;
    }
    .col_sucess {
      color: #2fc348;
    }
  }
  .steps_content_day {
    line-height: 60px;
    .steps_content_day_lt {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #222222;
    }
    .content_day {
      width: 118px;
      height: 42px;
      border-radius: 8px;
      margin: 0 20px;
    }
    .steps_content_day_rt {
      font-size: 14px;
      font-weight: 400;
      color: #222222;
    }
    .content_sel {
      margin: 0 20px;
      width: 300px;
    }
    .switch_txt {
      padding: 0;
      line-height: 20px;
      margin: 10px;
      margin-left: 120px;
    }
  }
}
.content_sel {
  margin: 0 20px;
  width: 300px;
}
.next_btn {
  margin-top: 150px;
  margin-left: 50%;
  transform: translate(-50%);
  .btn {
    display: inline-block;
  }
}
.btn_box {
  margin: 0 auto;
  margin-top: 150px;
  text-align: center;
}
</style>
<style lang=""></style>
